import { ButtonQHDS, Card, CardContent, CardHeader } from '@components';
import { CONSTANT } from '@const';
import { Clock } from '@public';

import styles from './readingSubmissionIntro.module.scss';

export const ReadingSubmissionIntro = ({ beginForm }: { beginForm: () => void }) => {
	return (
		<div className={styles.container}>
			<div className={styles.timeEstimate}>
				<Clock customStyles={styles.clockIcon} />
				<div className={styles.timeTextContainer}>
					<h2 className={styles.timeText}>2-5 minutes</h2>
					<p className={styles.timeSubtext}>Estimated time to complete</p>
				</div>
			</div>
			<h1 className={styles.title}>Before you begin</h1>
			<section className={styles.section}>
				<h2 className={styles.sectionTitle}>
					This is completed by the holder of a relevant authorisation to provide a reading.
				</h2>
			</section>
			<p className={styles.note}>
				If you believe you have incorrectly submitted your meter reading, email&nbsp;
				<a href={`mailto:${CONSTANT.WATER_HUB_EMAIL}`} className={styles.link}>
					{CONSTANT.WATER_HUB_EMAIL}
				</a>
				.
				<br />
				<br />
				To report a faulty device, submit an issue via the &apos;Report issue&apos; tab or contact
				your&nbsp;
				<a href={CONSTANT.CONTACT_URL} className={styles.link}>
					local business centre
				</a>
				.
			</p>
			<Card className={styles.card}>
				<CardHeader>
					<h3 className={styles.cardTitle}>Privacy statement</h3>
				</CardHeader>
				<CardContent>
					<p className={styles.cardContent}>
						Collection of information on this form is authorised by section 111 of the Water
						Regulation 2016 and will be used by the department for the purpose of processing your
						meter reading. The department may be required or authorised by legislation to disclose
						your information to other third parties. The information may be searchable, disclosed to
						and used by the public as allowed, authorised or required by legislation.
					</p>
				</CardContent>
			</Card>
			<div className={styles.buttonContainer}>
				<ButtonQHDS type="primary" size="large" onClick={() => beginForm()}>
					Begin
				</ButtonQHDS>
			</div>
		</div>
	);
};
